export class LevelSelectThumb extends Phaser.GameObjects.Container {
  constructor(scene, config, stars) {
    super(scene);

    this.id = config.id;
    const panel = scene.add.image(0, 0, 'shared_ui', 'select_lvl_' + config.id).setOrigin(0);
    this.add(panel);
    // this.add(scene.add.image(0, 0, 'shared_ui', 'level_select_panel_header').setOrigin(0));

    this.add(
      scene.add.image(panel.width * 0.5, 35, 'shared_ui', 'stars_0' + (stars || '0')).setScale(0.6)
    );

    this.disabledPanel = scene.add.image(0, 0, 'shared_ui', 'level_select_alpha').setOrigin(0);
    this.add(this.disabledPanel);

    this.width = this.disabledPanel.width;
    this.height = this.disabledPanel.height;

    this.disable();
  }

  enable() {
    this.disabledPanel.visible = false;
    this.enableInteractive();
  }

  disable() {
    this.disabledPanel.visible = true;
    this.removeInteractive();
  }

  dispatchSelect() {
    this.emit('select', this);
  }

  enableInteractive() {
    this.setInteractive({
      useHandCursor: true,
      hitArea: new Phaser.Geom.Rectangle(
        this.width * 0.5,
        this.height * 0.5,
        this.width,
        this.height
      ),
      hitAreaCallback: Phaser.Geom.Rectangle.Contains,
    });
  }
}
